<template>
<div class="app-container" v-loading="loading">
  <div class="content">
      <div class="header-nav">
        <div class="back-btn" @click="popBack"><i class="el-icon-back"></i></div> <div class="list-title">项目列表</div>
      </div>
      <div v-for="project in projectList" :key="project.id" class="list-item" @click="dcpList(project)">
        <!-- <span>buid: {{bu.id}}</span> -->
        <span>{{project.name}}</span>
        <i class="el-icon-arrow-right"></i>
      </div>
  </div>
</div>
</template>

<script>

import utils from '@/utils/domain';
import Axios from 'axios'
const axios = Axios.create({ })

export default {
components: {

},
data() {
  return {
    projectList: [],
    loading: false,
    buId: ""
  };
},
computed: {

},
watch: {

},
methods: {
  popBack() {
    this.$router.back()
  },
    getProjectList() {
        this.loading = true
        let token = this.$store.state.loginToken

        let data = {
          needPage: false,
          page: 0,
          search: '',
          size: 10,
          buId: this.buId
        }
        axios.defaults.withCredentials = true
        token && axios({
          url: utils.getDomain() + '/workspace/listProjects',
          method: 'POST',
          headers: {
            'x-api-token': token,
            'Content-Type':'application/json'
          },
          data
        })
        .then(({ data }) => {
          console.log("resp_data", data)
          this.loading = false
          if(data.code === 'common.success') {
            this.projectList = data.data.list
          }
        })
        .catch(( error ) => {
          this.loading = false
          console.log("error_occur", error)
        })
    },
    dcpList(project){
      console.log("select-bu", project)
      let buId = this.buId
      this.$router.push({path: "/projectdcplist", query: {
        projectId: project.id,
        uuid: project.projectUUID,
        token: this.$store.state.loginToken
      }})
    }
},
created() {

},
mounted() {
  /// get token from url , and request bu list
  this.buId = this.$route.query.buId
  this.getProjectList()
},
}
</script>

<style lang="scss" scoped>

  .app-container {
    font-size: 16px;
    width: 100vw;
    max-width: 750px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    .content {
      flex: 1;

      .header-nav {
        display: flex;
        i {
          width: 20px;
          height: 20px;
        }
        .back-btn {
          padding: 10px;
          height: 20px;
          font-size: 16px;
        }
      }
      
      .list-title {
        padding: 10px;
        height: 20px;
        color: #999;
        font-size: 16px;
      }
      .list-item {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        margin: 10px;
        margin-top: 15px;
        width: calc(100vw - 40px);
        max-width: 750px;
        box-shadow: 0 0 0 2px #ffffff, 0 0 6px 3px #cccccc;
      }
    }
  }
</style>